export enum MerlinRoutes {
  LOGOUT_REDIRECT = '/logout?redirect_uri',
}
